/**
 * className 合成ヘルパ（Unit 005 デザインシステム）
 *
 * 真偽値を除外してクラス文字列を「加算（連結）」するだけの極小ユーティリティ。
 * 依存最小化のため clsx / tailwind-merge は採用しない。
 *
 * 重要: 本ヘルパは Tailwind ユーティリティの「衝突解決」を行わない（append-only）。
 *       「利用側 className を末尾に置けば後勝ちで上書きできる」とは保証しない。
 *       同一プロパティの衝突回避は各コンポーネントの variant マップ設計で担保する。
 */
export type ClassValue = string | false | null | undefined

export function cn(...inputs: ClassValue[]): string {
  return inputs.filter(Boolean).join(' ')
}
